import { lighten, useTheme } from '@mui/material';
import * as React from 'react';
export const LangIcon = () => {
    const theme = useTheme();
    const primaryColour = theme.colors.other.icon.stroke.primary;
    const lightBorder = lighten(primaryColour, 0.8);
    const lightBg = lighten(primaryColour, 0.9);
    const white = '#fff';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <rect
                width={31}
                height={31}
                x={16.5}
                y={16.5}
                fill={white}
                stroke={primaryColour}
                rx={5.5}
            />
            <rect width={31} height={31} x={1.5} y={1.5} fill={white} stroke={white} rx={5.5} />
            <rect width={32} height={32} fill={primaryColour} rx={6} />
            <rect
                width={31}
                height={31}
                x={0.5}
                y={0.5}
                fill={lightBg}
                stroke={lightBorder}
                rx={5.5}
            />
            <rect
                width={21.333}
                height={1.333}
                x={5.334}
                y={7.333}
                fill={primaryColour}
                rx={0.667}
            />
            <rect
                width={14.667}
                height={1.333}
                x={5.334}
                y={15.334}
                fill={primaryColour}
                rx={0.667}
            />
            <rect
                width={21.333}
                height={1.333}
                x={5.334}
                y={23.334}
                fill={primaryColour}
                rx={0.667}
            />
            <path
                fill={primaryColour}
                fillRule="evenodd"
                d="M26.356 33.333a.666.666 0 0 0-.536.292.667.667 0 0 0-.1.133l-3.93 6.806a.667.667 0 0 0 1.154.667l3.79-6.565h8.722a.667.667 0 0 0 0-1.333h-9.1Zm7.074-5.426 7.693 13.324a.667.667 0 1 0 1.154-.667l-8.82-15.277v2.046c0 .194-.01.385-.027.574Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
